<template>
  <v-app-bar flat class="border-b">
    <template v-slot:prepend>
      <v-avatar 
        :image="require(`@/assets/logo.png`)"
        :to="{name:'home'}"
        rounded="0"
      ></v-avatar>
    </template>
    <v-app-bar-title class="hidden-xs-and-down" ><router-link :to="{name:'home'}" style="text-decoration: none; color: #152F59;">EngeBIO Nordeste</router-link></v-app-bar-title>
    
    
    <template v-slot:append>
      <v-app-bar-nav-icon v-if="mobile"  @click="isDrawerOpen"></v-app-bar-nav-icon>
      <div v-else>
        <v-btn :to="{name:'home'}">Home</v-btn>
        <v-menu transition="scale-transition">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props"> Áreas </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="(item, i) in itemsAreas" :key="i">
              <v-btn color="transparent" :elevation="0" :to="{name:`${item.url}`}">{{ item.title }}</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn>Clientes</v-btn>
        <v-btn href="http://www.engebio-ne.com.br/arquivos/login.php" target="_blank">Intranet</v-btn>
        <v-menu transition="scale-transition">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props"> Novidades </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="(item, i) in itemsNovidades" :key="i">
              <v-list-item-title>
                <v-btn color="transparent" :elevation="0" :to="{name:`${item.url}`}">{{ item.title }}</v-btn>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn :to="{name:'contact'}">Contato</v-btn>
        <v-btn :to="{name:'about'}">Sobre</v-btn>
      </div>
    </template>
  </v-app-bar>
</template>

<script>
import { mapMutations } from 'vuex';
import { useDisplay } from 'vuetify'

export default {
  name: "header-component",
  setup() {
    const { mobile } = useDisplay();
    return {
      mobile
    }
  },
  data: () => ({
    itemsAreas: [
      { title: "Calibração e Ensaios", url:'areas.calibracoes' },
      { title: "Elaboração de Projetos", url:'areas.projetos'},
      { title: "Engenharia Ambiental", url:'engenharia.ambiental'},
      { title: "Engenharia Clínica", url:'engenharia.clinica'},
      { title: "Engenharia Elétrica", url:'engenharia.eletrica'},
      { title: "Inspeção ultrassônica", url:'inspecao.ultrassonica'},
      { title: "Treinamento Operacional", url:'treinamento.operacional'},
    ],
    itemsPlano: [
      { title: "Gestão da Manutenção" },
      { title: "Ensaios e Calibrações" },
    ],
    itemsNovidades: [
      { title: "certificações" , url:'certificados'},
    ],
  }),
  methods: {
    ...mapMutations(['IS_DRAWER_OPEN']),
    isDrawerOpen() {
      this.IS_DRAWER_OPEN();
    },
  },
};
</script>


<style>
</style>